/* ConeBarn product-card image navigation: no DOM reordering */
(() => {
  function enable(root) {
    (root || document).querySelectorAll("#product-grid > .grid__item").forEach((item) => {
      const link = item.querySelector('a[href*="/products/"]');
      const media = item.querySelector(".card__inner") || item.querySelector(".card__media");
      if (!link || !media || media.dataset.cbxMediaLink) return;
      media.dataset.cbxMediaLink = "true";
      media.classList.add("cb-card-media-link-target");
      media.setAttribute("role", "link");
      media.tabIndex = 0;
      media.setAttribute("aria-label", "View " + link.textContent.trim());
      const open = () => location.assign(link.href);
      media.addEventListener("click", (event) => {
        if (!(event.target instanceof Element) || !event.target.closest("a,button,input,select,textarea")) open();
      });
      media.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") { event.preventDefault(); open(); }
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => enable(document));
  else enable(document);
  document.addEventListener("shopify:section:load", (event) => enable(event.target));
})();